module.exports = __webpack_public_path__ + "img/dropdown.973087b9.gif";